import moment from "moment";

// Utilidades de rango de fechas compartidas entre los stores de Resultados,
// Ventas y Gastos. Mantener las dos funciones aquí evita que cada store
// duplique la misma lógica de switch + buildMonthHeaders.

export function resolveDateRange(endMonth, selectedPeriodRange) {
    const refEnd = moment(endMonth).endOf("month");
    const endDate = refEnd.format("YYYY-MM-DD");
    let initDate;

    switch (selectedPeriodRange) {
        case "lastYear":
            initDate = moment(refEnd).subtract(12, "months").startOf("month").format("YYYY-MM-DD");
            break;
        case "last24months":
            initDate = moment(refEnd).subtract(24, "months").startOf("month").format("YYYY-MM-DD");
            break;
        case "actualYear":
            initDate = moment(refEnd).startOf("year").format("YYYY-MM-DD");
            break;
        case "previousYear":
            initDate = moment(refEnd).startOf("year").format("YYYY-MM-DD");
            break;
        default:
            initDate = moment(refEnd).subtract(12, "months").startOf("month").format("YYYY-MM-DD");
    }

    return { initDate, endDate };
}

export function buildMonthHeaders(initDate, endDate) {
    const headers = [];
    let cursor = moment(initDate).startOf("month");
    const end = moment(endDate).startOf("month");

    while (cursor.isSameOrBefore(end)) {
        headers.push(cursor.format("MMM YYYY").replace(".", ""));
        cursor.add(1, "months");
    }
    return headers;
}
